import React from "react";

import styles from "./login.module.scss";

const LoginWelcome = () => {
	return (
		<span className={styles.welcomeText}>
			<h2>
				<b className="text-uppercase">Login</b>
			</h2>
			<div>Welcome back! Please login to your account.</div>
		</span>
	);
};

export { LoginWelcome };
